function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWedge0Full = function SvgWedge0Full(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M65.068 17.763c2.102-3.639.566-7.736-3.423-9.084 0 0-5.094-1.752-11.968-1.752S38.275 8.491 38.275 8.491c-3.989 1.321-5.526 5.391-3.423 9.03L46.2 37.17c2.103 3.639 5.553 3.639 7.655 0l11.213-19.407z"
  }));
};
export default SvgWedge0Full;